/*
 * NEGOTIA Utility Engine - gift finder (archetype: Selector).
 * Rule GIFT-SELECT v1 mirrors operations/utility-engine-rules.md exactly. Do not change without a new rule version.
 * Uses UGE.track from uge-core.js when present.
 */
(function () {
  'use strict';

  var UGE = window.UGE || {};
  UGE.GIFT_SELECT_VERSION = 'GIFT-SELECT v1';
  UGE.GIFT_GROUPS = {
    work: ['laptop sleeve', 'laptop folio', 'briefcase', 'backpack'],
    travel: ['weekender', 'wash bag'],
    everyday: ['wallet', 'wash bag']
  };
  UGE.GIFT_BANDS = { b1: [0, 6000], b2: [6001, 10000], b3: [10001, 17500], b4: [17501, 1000000000] };
  UGE.GIFT_MAX = 3;

  function cmp(a, b) { return a < b ? -1 : (a > b ? 1 : 0); }

  // products: [{handle, title, price (cents), type, avail}], in collection order.
  // Returns [{p, flag}] with flag 'in' | 'below' | 'above'.
  UGE.giftSelect = function (products, who, budget, use) {
    var group = UGE.GIFT_GROUPS[use] || [], band = UGE.GIFT_BANDS[budget];
    if (!band) return [];
    var seen = {}, models = [];
    products.forEach(function (p) {
      if (seen[p.title] || !p.avail || group.indexOf(p.type) === -1) return;
      seen[p.title] = true; models.push(p);
    });
    var lo = band[0], hi = band[1];
    var inb = models.filter(function (p) { return p.price >= lo && p.price <= hi; });
    inb.sort(function (a, b) {
      var d = who === 'colleague' ? a.price - b.price : b.price - a.price;
      return d || cmp(a.title, b.title);
    });
    var out = inb.slice(0, UGE.GIFT_MAX).map(function (p) { return { p: p, flag: 'in' }; });
    if (out.length < 2) {
      var mid = (lo + Math.min(hi, 30000)) / 2;
      var rest = models.filter(function (p) { return !(p.price >= lo && p.price <= hi); });
      rest.sort(function (a, b) { return (Math.abs(a.price - mid) - Math.abs(b.price - mid)) || cmp(a.title, b.title); });
      rest.slice(0, UGE.GIFT_MAX - out.length).forEach(function (p) { out.push({ p: p, flag: p.price < lo ? 'below' : 'above' }); });
    }
    return out;
  };

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function track(n, p) { if (typeof UGE.track === 'function') UGE.track(n, p); }

  function initGift(root) {
    var dataEl = root.querySelector('script[data-uge-gift-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent), L = data.labels, tool = 'gift-finder';
    var state = { who: null, budget: null, use: null };
    var out = root.querySelector('[data-uge-gift-result]');
    track('uge_tool_view', { tool: tool, rule_version: UGE.GIFT_SELECT_VERSION });

    function card(r) {
      var p = r.p;
      return '<a class="uge-card" href="' + esc(p.url) + '" data-uge-product="' + esc(p.handle) + '">' +
        (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400">' : '') +
        (r.flag !== 'in' ? '<span class="uge-badge uge-badge--snug">' + esc(L['flag_' + r.flag]) + '</span>' : '') +
        '<span class="uge-card__title">' + esc(p.title) + '</span>' +
        '<span class="uge-card__price">' + esc(p.price_f) + '</span></a>';
    }

    function render() {
      if (!state.who || !state.budget || !state.use) return;
      var res = UGE.giftSelect(data.products, state.who, state.budget, state.use);
      track('uge_query', { tool: tool, term: state.who + '|' + state.budget + '|' + state.use, rule_version: UGE.GIFT_SELECT_VERSION });
      var html;
      if (!res.length) {
        track('uge_no_result', { tool: tool, term: state.who + '|' + state.budget + '|' + state.use });
        html = '<p class="uge-answer">' + esc(L.none) + '</p>';
      } else {
        track('uge_result', { tool: tool, matches: res.length, rule_version: UGE.GIFT_SELECT_VERSION });
        html = '<p class="uge-answer">' + esc(L.answer.replace('[n]', res.length)) + '</p>' +
          '<div class="uge-cards">' + res.map(card).join('') + '</div>';
        if (state.use === 'work' && L.fit_url) html += '<p class="uge-more"><a href="' + esc(L.fit_url) + '">' + esc(L.fit_hint) + '</a></p>';
      }
      if (L.gifts_url) html += '<p class="uge-more"><a href="' + esc(L.gifts_url) + '">' + esc(L.more) + '</a></p>';
      out.innerHTML = html; out.hidden = false;
    }

    root.querySelectorAll('[data-uge-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.getAttribute('data-uge-q');
        state[q] = b.getAttribute('data-uge-v');
        root.querySelectorAll('[data-uge-q="' + q + '"]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        render();
      });
    });
    out.addEventListener('click', function (e) {
      var a = e.target.closest('[data-uge-product]');
      if (a) track('uge_product_click', { tool: tool, product: a.getAttribute('data-uge-product'), rule_version: UGE.GIFT_SELECT_VERSION });
    });
  }

  UGE.initGift = function () {
    document.querySelectorAll('[data-uge-gift]:not([data-uge-ready])').forEach(function (el) { el.setAttribute('data-uge-ready', ''); initGift(el); });
  };
  window.UGE = UGE;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', UGE.initGift); else UGE.initGift();
    document.addEventListener('shopify:section:load', UGE.initGift);
  }
})();
